import { render } from "./UnitexInvoice.vue?vue&type=template&id=3b7ecd76&scoped=true"
import script from "./UnitexInvoice.vue?vue&type=script&lang=js"
export * from "./UnitexInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7ecd76"]])

export default __exports__